import SelectCustom from '@design/objects/select-custom/twig/assets'
import type { SelectCustomConfig } from '@design/objects/select-custom/twig/assets'

export default (element: HTMLDetailsElement, config: SelectCustomConfig = {}): SelectCustom | undefined => {
  const containerEl = element.closest<HTMLElement>('.o-form__block')

  if (!containerEl) {
    return
  }

  const labelEl = containerEl.querySelector<HTMLElement>('.o-form__label')

  if (!labelEl) {
    return
  }

  const newConfig = { ...config }

  const onFocus: SelectCustomConfig['onFocus'] = () => {
    containerEl.classList.add('o-form__field--focused')
  }

  newConfig.onFocus = () => {
    onFocus()
    config.onFocus?.()
  }

  const onBlur: SelectCustomConfig['onBlur'] = () => {
    containerEl.classList.remove('o-form__field--focused')
  }

  newConfig.onBlur = () => {
    onBlur()
    config.onBlur?.()
  }

  const onClick: SelectCustomConfig['onClick'] = () => {
    containerEl.classList.remove('o-form__field--valid')
    containerEl.classList.remove('o-form__field--invalid')
  }

  newConfig.onClick = () => {
    onClick()
    config.onClick?.()
  }

  const onValidFields: SelectCustomConfig['onValidFields'] = () => {
    containerEl.classList.add('o-form__field--valid')
  }

  newConfig.onValidFields = (cfg) => {
    onValidFields(cfg)
    config.onValidFields?.(cfg)
  }

  const onInvalidFields: SelectCustomConfig['onInvalidFields'] = () => {
    containerEl.classList.add('o-form__field--invalid')
  }

  newConfig.onInvalidFields = (cfg) => {
    onInvalidFields(cfg)
    config.onInvalidFields?.(cfg)
  }

  const selectCustom = new SelectCustom(element, newConfig)

  labelEl.addEventListener('click', (e) => {
    e.preventDefault()
    e.stopPropagation()

    selectCustom.element.click()
    selectCustom.element.open = !selectCustom.element.open
  })

  return selectCustom
}
